import apiProductSupplier from '../../../api/productSupplier';

const defaultState = () => ({
	productSupplierAll: [],
	productSupplierAllPagination: '',
	productWarehouse: [],
	productSupplier: [],
	response: {
		code: '',
		message: ''
	},
	responseError: {},
	alert: ''
});

const state = defaultState();

const getters = {
	
};

const mutations = {
	setProductSupplierAll(state, data) {
		state.productSupplierAll = data.data
		state.productSupplierAllPagination = data.pagination
	},
	setProductWarehouse(state, data) {
		state.productWarehouse = data
	},
	setProductSupplier(state, data) {
		state.productSupplier = data
	},
	saveResponse(state, data) {
		state.response = data
	},
	validationError(state, data) {
		state.responseError = data
	},
	failed(state, data) {
		state.alert = data
	},
	clearDataProductSupplier(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getProductSupplierAll({ commit }, params){
		apiProductSupplier.getProductSupplierAll(params).then(({ data: { data } }) => {
			commit('setProductSupplierAll', { data: data.results, pagination: data.pagination });
		}).catch(() => {
			commit('setProductSupplierAll', { data: [], pagination: {} });
		});
	},
	getProductWarehouseBySupplier({ commit }, params){
		apiProductSupplier.getProductWarehouseBySupplier(params).then(({ data: { data } }) => {
			commit('setProductWarehouse', data.results );
		}).catch(() => {
			commit('setProductWarehouse', [] );
		});
	},
	getProductSupplierBySupplier({ commit }, params){
		apiProductSupplier.getProductSupplierBySupplier(params).then(({ data: { data } }) => {
			commit('setProductSupplier', data.results );
		}).catch(() => {
			commit('setProductSupplier', [] );
		});
	},
	async exportProductSupplier({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiProductSupplier.exportProductSupplier(params).then(({ data: { data } }) => {
			dispatch('success', data.results)
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data produk supplier'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	async syncProduct({ commit, dispatch }, params) {
		await apiProductSupplier.syncProduct(params).then( res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menambah produk supplier'
			}, { root: true });
		});
	},
	async asyncProduct({ commit, dispatch }, params) {
		await apiProductSupplier.asyncProduct(params).then( res => {
			const data = res.data;
			commit("saveResponse", data);
			commit('setSnackbar', {
				show: true,
				color: 'green accent-4',
				text: data.message
			}, { root: true });
		})
		.catch( err => {
			const data = err.response.data
			dispatch("errorHandler", data)
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal menghapus produk supplier'
			}, { root: true });
		});
	},
	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},
	errorHandler({ commit }, response) {
		switch (response.message) {
			case 'error_validation':
			commit('validationError', response.data);
			break;

			default:
			commit('failed', { code: 'error_response', type: 'error', message: response.message });
			break;
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};